// extracted by mini-css-extract-plugin
export var formContainer = "FormSection-module--formContainer--G8fyx";
export var formContent = "FormSection-module--formContent--EcFcl";
export var formDescription = "FormSection-module--formDescription--ypDFR";
export var formHeader = "FormSection-module--formHeader--AOTlt";
export var formImage = "FormSection-module--formImage--UCBRd";
export var formSectionWrapper = "FormSection-module--formSectionWrapper--Sl5Oj";
export var formSubtitle = "FormSection-module--formSubtitle--mAiR3";
export var formTitle = "FormSection-module--formTitle--NuiZQ";
export var imageContainer = "FormSection-module--imageContainer--epaNM";